import ApiEndpoints from "./ApiEndpoints";
import {Store} from "../store";

export default class Api {
    /**
     *
     * @return {Promise<*>}
     */
    static async getPackages() {
        try {
            const packagesUrl = new URL(ApiEndpoints.packages);
            packagesUrl.searchParams.set('lang', Store.getters.getLang());
            const response = await fetch(packagesUrl.href);
            const packages = await response.json();
            return packages
                .map(({title, id, acf}) => ({
                    name: title.rendered,
                    id: id,
                    type: acf.package_info.type
                }))
                // .filter(e => e.type === 'request')
                .reverse();
        } catch (e) {
            console.error(e);
            throw new Error('error at getPackages() API call');
        }
    }

    /**
     *
     * @return {Promise<any>}
     */
    static async getIndustries() {
        try {
            const industriesUrl = new URL(ApiEndpoints.industries);
            industriesUrl.searchParams.set('lang', Store.getters.getLang());
            const response = await fetch(industriesUrl.href);
            return await response.json();
        } catch (e) {
            console.error(e);
            throw new Error('error at getIndustries() API call');
        }
    }

    /**
     * Implementation with default WP search endpoint
     * keep this method for legacy reasons or future projects \m/
     * @deprecated
     * @param value {string}
     * @return {Promise<any>}
     */
    static async searchKnowledgeRepository(value) {
        try {
            const searchUrl = new URL(ApiEndpoints.search);
            searchUrl.searchParams.set('search', value);
            searchUrl.searchParams.set('subtype', 'knowledge-repository');
            const response = await fetch(searchUrl.href);
            return await response.json();

        } catch (e) {
            console.error(e);
            throw new Error('error at searchKnowledgeRepository() API call');
        }
    }

    /**
     *
     * @param value {string}
     * @return {Promise<any>}
     */
    static async searchByKnowledgeRepository(value) {
        try {
            const searchUrl = new URL(ApiEndpoints.searchKnowledgeRepository);
            searchUrl.searchParams.set('s', value);
            searchUrl.searchParams.set('lang', Store.getters.getLang());
            const response = await fetch(searchUrl.href);
            if (!response.ok) {
                throw `status: ${response.status}`;
            }
            const searchResults = await response.json();
            return searchResults.map((result) => ({
                matchedTerm: result.terms.some(e => e.parent !== 0) ? result.terms.find(e => e.parent !== 0) : result.terms.find(e => e.parent === 0),
                ...result
            }))

        } catch (e) {
            throw new Error(`${e} at searchByKnowledgeRepository() API call`);
        }
    }

    /**
     *
     * @return {Promise<any>}
     */
    static async getSearchConfig() {
        try {
            const searchConfigUrl = new URL(ApiEndpoints.searchConfig);
            searchConfigUrl.searchParams.set('lang', Store.getters.getLang());
            const response = await fetch(searchConfigUrl.href);
            if (!response.ok) {
                throw `status: ${response.status}`;
            }
            return await response.json();

        } catch (error) {
            throw new Error(`${error} at searchByKnowledgeRepository() API call`);
        }
    }
}
